import { render } from "./Sleep.vue?vue&type=template&id=d540b480&scoped=true"
import script from "./Sleep.vue?vue&type=script&lang=js"
export * from "./Sleep.vue?vue&type=script&lang=js"

import "./Sleep.vue?vue&type=style&index=0&id=d540b480&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d540b480"]])

export default __exports__